export default "__VITE_ASSET__DCkhx7PB__"